import { NgModule, LOCALE_ID  } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule }   from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { registerLocaleData } from '@angular/common';
import localePL from '@angular/common/locales/pl';
import { NgHttpLoaderModule } from 'ng-http-loader';

import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';

registerLocaleData(localePL);

import { AppComponent } from './app.component';
import { RouterModule, Routes } from '@angular/router';
import { routing }        from './app.routing';
import { WelcomeOkComponent } from './welcome-ok';
import { WelcomeFailComponent } from './welcome-fail';
import { WelcomeNotFoundComponent } from './welcome-not-found';
import { SummaryComponent } from "./summary/summary.component";
import { LinkValidationResolve } from './service';
import { DictionaryMapperPipe } from './pipes';

@NgModule({
    imports: [
        BrowserModule,
        NgbModule.forRoot(),
        routing,
        HttpClientModule,
        MatProgressSpinnerModule,
        FormsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        NgHttpLoaderModule
    ],
    declarations: [
        AppComponent,
        WelcomeOkComponent,
        WelcomeFailComponent,
        WelcomeNotFoundComponent,
        SummaryComponent,
        DictionaryMapperPipe
    ],
    bootstrap: [AppComponent],
    providers: [
        LinkValidationResolve,
        { provide: LOCALE_ID, useValue: 'pl-PL'}
    ],
})
export class AppModule {}

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}